import UserLists from './UserLists.container';

export default UserLists;
